export default "__VITE_ASSET__3c704cc1__"